import { useState, useEffect, useCallback } from 'react';
import { FormikProps } from 'formik';
import { AddResourceFormValues } from '../types';
import { agencies } from '../../../api/agencies';
import { categories } from '../../../api/categories';
import { useAuth } from '../../../contexts/AuthContext';
import { UserRole } from '../../../api/users';

type SelectOption = {
  value: string;
  label: string;
};

export const useResourceFormFields = (formik: FormikProps<AddResourceFormValues>) => {
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } = formik;
  const [agencyOptions, setAgencyOptions] = useState<SelectOption[]>([]);
  const [categoryOptions, setCategoryOptions] = useState<SelectOption[]>([]);
  const { userData } = useAuth();

  const fetchData = useCallback(async () => {
    try {
      let agenciesData = [];
      const categoriesData = await categories.getAll();

      if (userData?.role === UserRole.ADMIN) {
        agenciesData = await agencies.getAll();
        setAgencyOptions(
          agenciesData.map((agency) => ({
            value: agency.id.toString(),
            label: agency.name,
          }))
        );
      } else {
        setAgencyOptions(
          userData?.agencies?.map((agency) => ({
            value: agency.id.toString(),
            label: agency.name,
          })) || []
        );
      }

      setCategoryOptions(
        categoriesData.map((c) => ({
          value: c.id.toString(),
          label: c.name,
        }))
      );
    } catch (error) {
      console.error('Failed to load data:', error);
    }
  }, [userData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    agencyOptions,
    categoryOptions,
  };
};
